import React, { useState } from "react";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Content from './content/Content'
import { width } from "styled-system";
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import useScript from '../../utils/customHooks/useScript';
import AntSwitch from '../../utils/props/AntSwitch'
import * as ROUTES from '../../routes';
import ArrowBackStandar from '../ArrowBack/ArrowBackStandar';
import MembershipCard from '../MembershipsCards/MembershipCard'
import ScrollToTop from '../ScrollToTop';
import MembershipModal from "../Modal/MembershipModal";
import { connect } from 'react-redux';
import { openModalPayments } from "../../store/actions/ModalsActions";
import "./Content.scss";

const membershipLawyers = [
  <p className='mship-card_features_text'>Posicionamiento y presencia Online dentro y fuera de la plataforma.</p>,
  <p className='mship-card_features_text'>Sitio web con dominio personalizado y branding de abogado.</p>,
  <p className='mship-card_features_text'>Publicación de artículos de su materia de especialidad.</p>,
  <p className='mship-card_features_text'>Generador de propuestas comerciales para sus clientes potenciales.</p>,
  <p className='mship-card_features_text'>Acceso a la comunidad de usuarios para interactuar con clientes potenciales.</p>,
  <p className='mship-card_features_text'>Perfil profesional Premium Abogado.</p>,
  <p className='mship-card_features_text'>Publicación de imágenes y videos relacionados a su experiencia profesional.</p>,
  <div className='mship-card_features_text'>
    <p className='mship-card_features_text-gray'>
      Acceso a Webinars impartidos por nuestros
      expertos legales y de marketing legal,
    </p>
    <p className='mship-card_features_text-blue'>
      Contacta Abogado® Academy
    </p>
  </div>,
  <p className='mship-card_features_text'>Soporte técnico de nuestros especialistas en Marketing legal.</p>,
  <p className='mship-card_features_text'>Campañas personalizadas para invitar a sus clientes a crear valoraciones y comentarios de su perfil.</p>,
]

const membershipLawFirm = [
  <p className='mship-card_features_text'>Posicionamiento y presencia Online dentro y fuera de la plataforma.</p>,
  <p className='mship-card_features_text'>Sitio web con dominio personalizado y branding de despacho.</p>,
  <p className='mship-card_features_text'>Publicación de artículos de los miembros del despacho.</p>,
  <p className='mship-card_features_text'>Generador de propuestas comerciales para sus clientes potenciales.</p>,
  <p className='mship-card_features_text'>Acceso a la comunidad de usuarios para interactuar con clientes potenciales.</p>,
  <p className='mship-card_features_text'>Perfil profesional completo de Despacho.</p>,
  <p className='mship-card_features_text'>Perfil profesional completo<br />al Titular de Despacho.</p>,
  <p className='mship-card_features_text'>Hasta 10 perfiles de socios y/o asociados dentro del perfil de Despacho</p>,
  <p className='mship-card_features_text'>Publicación de hasta 5 ubicaciones/sedes a nivel nacional.</p>,
  <p className='mship-card_features_text'>Publicación de imágenes y videos relacionados a su experiencia profesional.</p>,
  <div className='mship-card_features_text'>
    <p className='mship-card_features_text-gray'>
      Acceso a Webinars impartidos por nuestros
      expertos legales y de marketing legal, 
    </p>
    <p className='mship-card_features_text-blue'>
      Contacta Abogado® Academy
    </p>
  </div>,
  <p className='mship-card_features_text'>Soporte técnico de nuestros especialistas en Marketing legal.</p>,
  <p className='mship-card_features_text'>Campañas personalizadas para invitar a tus clientes a crear valoraciones y recomendaciones de tu perfil.</p>,
]

function Memberships(props) {

  const isMobile = useMediaQuery('(max-width: 768.98px)')
  
  const [state, setState] = useState({
    yearlyLawyer: props.role ? false : true,
  });

  const { openModalPayments } = props;
  let period = state.yearlyLawyer ? "anual" : "monthly"
  let cost = ''
  if (props.role === 'lawyer') {
    cost = !state.yearlyLawyer ? '$1,299' : '12,471'
  } else if (props.role === 'lawFirm') {
    cost = !state.yearlyLawyer ? '$1,999' : '19,191'
  }

  const handleOpenModal = role => {
    if(!props.role){
      openModalPayments(true, 'noSession', period);
    } else {
      openModalPayments(true, role, period, cost);
    }
  }

  const setToYear = () => {
    setState({ yearlyLawyer: true })
  };

  const setToMonth = () => {
    setState({ yearlyLawyer: false })
  };

  return (
    <>
    <MembershipModal />
    <ScrollToTop />
    <div className="mships">
      <div className="mships-mainContent">
        <div className="mships-content_arrow">
            <ArrowBackStandar text="Regresar"/>
        </div>
        <div className='mships-content_titles'>
          <p className="mships-mainTitle">Membresías y costos</p>
          <p className="mships-description">
            Sea parte de la plataforma{isMobile ? <br/> : null} con los mejores abogados en México
          </p>
          <div className='mships-switch'>
            <div className='mships-switch-container1'>
              <div
                onClick={setToMonth}
                className={`mships-switch-container1_square${!state.yearlyLawyer ? 'On' : 'Off'}`}
              >
                <p className={`mships-switch-container1_text${!state.yearlyLawyer ? 'On' : 'Off'}`}>
                  Inversión mensual
                </p>
              </div>
              <div
                onClick={setToYear}
                className={`mships-switch-container1_square${state.yearlyLawyer ? 'On' : 'Off'}`}
              >
                <p className={`mships-switch-container1_text${state.yearlyLawyer ? 'On' : 'Off'}`}>
                  Inversión anual
                </p>
                <p className={`mships-switch-container1_smallText${state.yearlyLawyer ? 'On' : 'Off'}`}>
                  Ahorras - 20%
                </p>
              </div>
            </div>
            <div className='mships-switch-container2'>Recomendado</div>
          </div>
          <div className='mships-container_cardsTogether'>
            <MembershipCard
              type='lawyer'
              textBtn='Empiece ahora'
              title='ABOGADO'
              cost={state.yearlyLawyer ? '12,471' : '1,299'}
              oldCost={state.yearlyLawyer ? '15,588' : ''}
              handleClick={() => handleOpenModal('lawyer')}
              infoMembership={membershipLawyers}
              yearly={state.yearlyLawyer}
            />
            <MembershipCard
              type='lawFirm'
              textBtn='Empiece ahora'
              title={'DESPACHO'}
              yearly={state.yearlyLawyer}
              handleClick={() => handleOpenModal('lawFirm')}
              cost={state.yearlyLawyer ? '19,191' : '1,999'}
              oldCost={state.yearlyLawyer ? '23,988' : ''}
              infoMembership={membershipLawFirm}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  openModalPayments: (open, membershipRole, typeMembership, typePayment, membershipPeriod) =>
    dispatch(openModalPayments(open, membershipRole, typeMembership, typePayment, membershipPeriod))
})

const mapStateToProps = (state) => ({
  role: state.authClient.role,
  modalPayments: state.ModalReducer.openModalPayments
});

export default connect(mapStateToProps, mapDispatchToProps)(Memberships);

